/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Lazy loading of the component PageNewsManage
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import loadable from '@utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageNewsManage" */ './PageNewsManage'), undefined);
